import { render, staticRenderFns } from "./EditSupplier.vue?vue&type=template&id=5f57c0cf&scoped=true&"
import script from "./EditSupplier.vue?vue&type=script&lang=js&"
export * from "./EditSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57c0cf",
  null
  
)

export default component.exports